Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 /* GOTCHA(G-BS02) */ ;
__p += '\n<div  id="' +
((__t = ( ctx.wizardKey )) == null ? '' : __t) +
'-header" class="d-flex flex-column">\n  <div\n    class="progress mb-2"\n    aria-valuenow="' +
((__t = ((ctx.currentPage+1)/ctx.panels.length*100)) == null ? '' : __t) +
'"\n    aria-valuemin="0"\n    aria-valuemax="100"\n    role="progressbar"\n  >\n    <div\n      class="progress-bar"\n      style="width: ' +
((__t = ((ctx.currentPage+1)/ctx.panels.length*100)) == null ? '' : __t) +
'%"\n    ></div>\n  </div>\n  <nav class="align-self-start">\n    <ul class="pagination nav nav-pills">\n      ';
 ctx.panels.forEach(function(panel, index) { ;
__p += '\n      <li class="nav-item">\n        <button\n          tabindex="0"\n          data-index="' +
((__t = (index)) == null ? '' : __t) +
'"\n          class="nav-link' +
((__t = (ctx.currentPage < index ? ' disabled' : '')) == null ? '' : __t) +
'' +
((__t = (ctx.currentPage === index ? ' active' : '')) == null ? '' : __t) +
'"\n          ref="' +
((__t = (ctx.wizardKey)) == null ? '' : __t) +
'-link"\n          ' +
((__t = (ctx.currentPage < index ? ' disabled' : '')) == null ? '' : __t) +
'\n          ' +
((__t = (ctx.currentPage === index ? ' aria-selected="true"' : '')) == null ? '' : __t) +
'\n        >\n          ' +
((__t = (ctx.t(panel.title, { _userInput: true }))) == null ? '' : __t) +
'\n          ';
 if (panel.tooltip && ctx.currentPage === index) { ;
__p += '\n          <i ref="' +
((__t = (ctx.wizardKey)) == null ? '' : __t) +
'-tooltip" class="' +
((__t = (ctx.iconClass('question-sign'))) == null ? '' : __t) +
' text-muted" data-tooltip="' +
((__t = (panel.tooltip)) == null ? '' : __t) +
'"></i>\n          ';
 } ;
__p += '\n        </button>\n      </li>\n      ';
 }) ;
__p += '\n    </ul>\n  </nav>\n</div>';
return __p
}